import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Header from '../components/Header';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUsers, FiShield, FiPackage, FiKey, FiActivity, FiSettings, FiEdit2, FiTrash2, FiCopy, FiPlus } = FiIcons;

const Admin = () => {
  const [activeTab, setActiveTab] = useState('users');

  const tabs = [
    { id: 'users', label: 'Benutzer', icon: FiUsers },
    { id: 'roles', label: 'Rollen', icon: FiShield },
    { id: 'tools', label: 'Tools', icon: FiPackage },
    { id: 'entitlements', label: 'Berechtigungen', icon: FiKey },
    { id: 'webhooks', label: 'Webhooks', icon: FiActivity },
    { id: 'audit', label: 'Audit-Log', icon: FiSettings }
  ];

  const mockUsers = [
    { id: 1, email: 'user1@example.com', role: 'User', created: '2024-01-15', status: 'Aktiv' },
    { id: 2, email: 'user2@example.com', role: 'Premium', created: '2024-01-20', status: 'Aktiv' }
  ];

  const mockRoles = [
    { id: 1, name: 'User', description: 'Standard-Benutzer mit Basis-Zugriff', users: 45 },
    { id: 2, name: 'Premium', description: 'Premium-Benutzer mit erweiterten Rechten', users: 12 }
  ];

  const mockTools = [
    { id: 1, name: 'Tool 1', slug: 'tool-1', category: 'Analyse', status: 'Aktiv' },
    { id: 2, name: 'Tool 2', slug: 'tool-2', category: 'Produktivität', status: 'Aktiv' }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'users':
        return (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-[var(--color-text-dark)]">Benutzerverwaltung</h2>
              <button className="btn-primary flex items-center space-x-2">
                <SafeIcon icon={FiPlus} />
                <span>Benutzer hinzufügen</span>
              </button>
            </div>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              <table className="w-full">
                <thead className="bg-[var(--color-light)]">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-[var(--color-text-dark)]">E-Mail</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-[var(--color-text-dark)]">Rolle</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-[var(--color-text-dark)]">Erstellt</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-[var(--color-text-dark)]">Status</th>
                    <th className="px-6 py-4 text-right text-sm font-semibold text-[var(--color-text-dark)]">Aktionen</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[var(--color-border)]">
                  {mockUsers.map((user) => (
                    <tr key={user.id} className="hover:bg-[var(--color-light)] transition-colors">
                      <td className="px-6 py-4 text-sm text-[var(--color-text-dark)]">{user.email}</td>
                      <td className="px-6 py-4">
                        <span className="px-3 py-1 text-xs font-medium bg-[var(--color-light)] text-[var(--color-secondary)] rounded-full">
                          {user.role}
                        </span>
                      </td>
                      <td className="px-6 py-4 text-sm text-[var(--color-text-light)]">{user.created}</td>
                      <td className="px-6 py-4">
                        <span className="px-3 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">
                          {user.status}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex justify-end space-x-2">
                          <button className="p-2 hover:bg-[var(--color-light)] rounded-lg transition-colors">
                            <SafeIcon icon={FiEdit2} className="text-[var(--color-primary)]" />
                          </button>
                          <button className="p-2 hover:bg-red-50 rounded-lg transition-colors">
                            <SafeIcon icon={FiTrash2} className="text-[var(--color-error)]" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );

      case 'roles':
        return (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-[var(--color-text-dark)]">Rollenverwaltung</h2>
              <button className="btn-primary flex items-center space-x-2">
                <SafeIcon icon={FiPlus} />
                <span>Rolle erstellen</span>
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {mockRoles.map((role) => (
                <motion.div
                  key={role.id}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  className="neon-border-container"
                >
                  <div className="card">
                    <div className="flex justify-between items-start mb-4">
                      <div className="p-3 bg-[var(--color-light)] rounded-lg">
                        <SafeIcon icon={FiShield} className="text-2xl text-[var(--color-primary)]" />
                      </div>
                      <div className="flex space-x-2">
                        <button className="p-2 hover:bg-[var(--color-light)] rounded-lg transition-colors">
                          <SafeIcon icon={FiEdit2} className="text-[var(--color-primary)]" />
                        </button>
                        <button className="p-2 hover:bg-[var(--color-light)] rounded-lg transition-colors">
                          <SafeIcon icon={FiCopy} className="text-[var(--color-secondary)]" />
                        </button>
                        <button className="p-2 hover:bg-red-50 rounded-lg transition-colors">
                          <SafeIcon icon={FiTrash2} className="text-[var(--color-error)]" />
                        </button>
                      </div>
                    </div>
                    <h3 className="text-lg font-semibold text-[var(--color-text-dark)] mb-2">{role.name}</h3>
                    <p className="text-sm text-[var(--color-text-light)] mb-4">{role.description}</p>
                    <div className="text-sm text-[var(--color-text-light)]">
                      <span className="font-medium">{role.users}</span> Benutzer
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        );

      case 'tools':
        return (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-[var(--color-text-dark)]">Tool-Verwaltung</h2>
              <button className="btn-primary flex items-center space-x-2">
                <SafeIcon icon={FiPlus} />
                <span>Tool hinzufügen</span>
              </button>
            </div>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
              <table className="w-full">
                <thead className="bg-[var(--color-light)]">
                  <tr>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-[var(--color-text-dark)]">Name</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-[var(--color-text-dark)]">Slug</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-[var(--color-text-dark)]">Kategorie</th>
                    <th className="px-6 py-4 text-left text-sm font-semibold text-[var(--color-text-dark)]">Status</th>
                    <th className="px-6 py-4 text-right text-sm font-semibold text-[var(--color-text-dark)]">Aktionen</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[var(--color-border)]">
                  {mockTools.map((tool) => (
                    <tr key={tool.id} className="hover:bg-[var(--color-light)] transition-colors">
                      <td className="px-6 py-4 text-sm font-medium text-[var(--color-text-dark)]">{tool.name}</td>
                      <td className="px-6 py-4 text-sm text-[var(--color-text-light)] font-mono">{tool.slug}</td>
                      <td className="px-6 py-4">
                        <span className="px-3 py-1 text-xs font-medium bg-[var(--color-light)] text-[var(--color-secondary)] rounded-full">
                          {tool.category}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="px-3 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">
                          {tool.status}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex justify-end space-x-2">
                          <button className="p-2 hover:bg-[var(--color-light)] rounded-lg transition-colors">
                            <SafeIcon icon={FiEdit2} className="text-[var(--color-primary)]" />
                          </button>
                          <button className="p-2 hover:bg-[var(--color-light)] rounded-lg transition-colors">
                            <SafeIcon icon={FiCopy} className="text-[var(--color-secondary)]" />
                          </button>
                          <button className="p-2 hover:bg-red-50 rounded-lg transition-colors">
                            <SafeIcon icon={FiTrash2} className="text-[var(--color-error)]" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );

      case 'entitlements':
        return (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-[var(--color-text-dark)]">Berechtigungsverwaltung</h2>
              <button className="btn-primary flex items-center space-x-2">
                <SafeIcon icon={FiPlus} />
                <span>Berechtigung erstellen</span>
              </button>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-8 text-center">
              <SafeIcon icon={FiKey} className="text-6xl text-[var(--color-text-light)] mx-auto mb-4" />
              <p className="text-[var(--color-text-light)]">Berechtigungen verwalten – verbinden Sie Benutzer/Rollen mit Tools</p>
            </div>
          </div>
        );

      case 'webhooks':
        return (
          <div>
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-[var(--color-text-dark)]">Webhook-Verwaltung</h2>
              <button className="btn-primary flex items-center space-x-2">
                <SafeIcon icon={FiPlus} />
                <span>Webhook hinzufügen</span>
              </button>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-8 text-center">
              <SafeIcon icon={FiActivity} className="text-6xl text-[var(--color-text-light)] mx-auto mb-4" />
              <p className="text-[var(--color-text-light)]">Webhooks für automatische Freischaltungen konfigurieren</p>
            </div>
          </div>
        );

      case 'audit':
        return (
          <div>
            <h2 className="text-2xl font-bold text-[var(--color-text-dark)] mb-6">Audit-Log</h2>
            <div className="bg-white rounded-xl shadow-sm p-8 text-center">
              <SafeIcon icon={FiSettings} className="text-6xl text-[var(--color-text-light)] mx-auto mb-4" />
              <p className="text-[var(--color-text-light)]">Alle Systemaktivitäten werden hier protokolliert</p>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-[var(--color-light)]">
      <Header />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl font-bold text-[var(--color-text-dark)] mb-2">
            Admin-Dashboard
          </h1>
          <p className="text-[var(--color-text-light)] mb-8">
            Verwalten Sie Benutzer, Rollen, Tools und Berechtigungen
          </p>

          <div className="bg-white rounded-xl shadow-sm mb-8 overflow-x-auto">
            <div className="flex border-b border-[var(--color-border)]">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 px-6 py-4 font-medium transition-colors whitespace-nowrap ${
                    activeTab === tab.id
                      ? 'text-[var(--color-primary)] border-b-2 border-[var(--color-primary)]'
                      : 'text-[var(--color-text-light)] hover:text-[var(--color-text-dark)]'
                  }`}
                >
                  <SafeIcon icon={tab.icon} className="text-xl" />
                  <span>{tab.label}</span>
                </button>
              ))}
            </div>
          </div>

          <motion.div
            key={activeTab}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3 }}
          >
            {renderContent()}
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Admin;